module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content pd-025"
  }, [_c('div', {
    staticClass: "card mt-20"
  }, [_c('div', {
    staticClass: "pd-020"
  }, [_c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("店铺logo（400*400）")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.mainPicView),
      expression: "formItem.mainPicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.mainPicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('mainPicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.mainPicView),
      expression: "!formItem.mainPicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadMain
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "filed-input-box bd-bot"
  }, [_c('div', {
    staticClass: "required fs-32 color-333"
  }, [_vm._v("店铺图片（750*300）")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 pl-15"
  }, [_vm._v("(支持jpg、bmp格式图片，大小不要超过1M/张)")]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.indexPicView),
      expression: "formItem.indexPicView"
    }],
    staticClass: "pic-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.formItem.indexPicView,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clean",
    on: {
      "click": function($event) {
        return _vm.delImg('indexPicView')
      }
    }
  })]), _vm._v(" "), _c('van-uploader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formItem.indexPicView),
      expression: "!formItem.indexPicView"
    }],
    attrs: {
      "preview-size": "1.45rem",
      "preview-image": false,
      "after-read": _vm.afterReadIndex
    },
    model: {
      value: (_vm.imgList),
      callback: function($$v) {
        _vm.imgList = $$v
      },
      expression: "imgList"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('div', {
    staticClass: "fs-32 color-333 left"
  }, [_vm._v("店铺介绍")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.shopDesc),
      expression: "formItem.shopDesc"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺介绍"
    },
    domProps: {
      "value": (_vm.formItem.shopDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "shopDesc", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("确定")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-register-state"
  }, [_c('div', {
    staticClass: "text color-999"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinlv color-999"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-999"
  }, [_vm._v("公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "alifont icon-jianjinhei color-999"
  }), _vm._v(" "), _c('div', {
    staticClass: "text color-main"
  }, [_vm._v("店铺设置")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0921a104","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/shopSetting.vue
// module id = j7Lz
// module chunks = 51